import { c as _c } from "react/compiler-runtime";
import type React from "react";
import type { CurationWavePreviewCardVariant } from "./types";
export const CurationPreviewShell: React.FC<{
  readonly variant: CurationWavePreviewCardVariant;
  readonly children: React.ReactNode;
}> = t0 => {
  const $ = _c(4);
  const {
    variant,
    children
  } = t0;
  if (variant === "sheet") {
    let t1;
    if ($[0] !== children) {
      t1 = <div className="tailwind-scope tw-w-full tw-overflow-hidden tw-rounded-t-lg tw-bg-[#131316] tw-text-iron-50">{children}</div>;
      $[0] = children;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== children) {
    t1 = <div className="tailwind-scope -tw-mx-4 -tw-my-3 tw-max-h-[calc(100vh-32px)] tw-w-[300px] tw-overflow-hidden tw-rounded-lg tw-bg-[#131316] tw-text-iron-50">{children}</div>;
    $[2] = children;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};